import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  icon: ReactNode;
  title: string;
  /** `ReactNode` para o Diagnóstico poder passar `—` e selos, não só string. */
  value: ReactNode;
  hint: string;
  accent: "default" | "danger" | "warn";
  className?: string;
}

/**
 * Extraído de `WricefCatalogTab` (era função privada, 3 call sites no
 * `SummaryHeader`). As cores literais dos acentos são preservadas de propósito:
 * trocá-las por tokens semânticos mudaria pixel e deixaria de ser refactor neutro.
 */
export function MetricCard({ icon, title, value, hint, accent, className }: MetricCardProps) {
  const accentClass =
    accent === "danger" ? "text-red-700" : accent === "warn" ? "text-amber-700" : "text-foreground";

  return (
    <Card className={cn("shadow-none border", className)}>
      <CardContent className="pt-4 space-y-1">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          {icon}
          <span>{title}</span>
        </div>
        <div
          data-testid="metric-card-value"
          className={cn("text-2xl font-semibold tabular-nums", accentClass)}
        >
          {value}
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">{hint}</p>
      </CardContent>
    </Card>
  );
}
